// The code in this file will load on every page of your site
import { cart } from 'wix-stores';
import wixUsers from 'wix-users';
import wixLocation from 'wix-location';


// カートアイコンテキストのID定義
const cartIconTextId = "cartIconQuantity";

$w.onReady(function () {
        // カートアイコンの数量を更新
        setCartIconQuantity();
        if(wixUsers.currentUser.loggedIn){
                console.log(wixLocation.url);
                if(wixLocation.url == "https://www.nkblive.com" || wixLocation.url == "https://www.nkblive.com/" || wixLocation.url.indexOf('https://www.nkblive.com/?siteRevision=') > -1){
                        $w('#txtRegister').hide();
                }else{
                        $w('#txtRegister2').hide();
                }
        }
});
export let globalVars = {

        test : "jfjfjaofijaofj",

        test2 : "what does 'jfjfjaofijaofj' mean BTW"

};

/**
 * カートアイコンの数量表示を設定
 */
export function setCartIconQuantity(){
        //カートの中身を取得
        cart.getCurrentCart()
        .then((currentCart) => {
                //カート内の商品を取得
                const itemCount = currentCart.totals.quantity;
                //カートアイコンに数量を設定
                // $w("#cartIcon2").label = " " + itemCount.toString();
                $w("#" + cartIconTextId).text = itemCount.toString();
        })
        .catch((error) => {
                console.error(error);
        });
}

/**
 * カートアイコンの数量表示を設定
 *  @param quantity 更新後の数量
 */
export function updateCartIconQuantity(quantity){
	$w("#" + cartIconTextId).text = quantity.toString();
}

/**
 * 商品の詳細説明文から商品のオプションを取得
 * @parma description 商品説明文
 */
export function getProductOptions(description){
	// let regex = /<p>###この行から下は送料計算に利用します。購入者には表示されません。###(.*)<\/p>/i;
	// let found = description.match(regex);
	// let temp = found[0].replace('<p>###この行から下は送料計算に利用します。購入者には表示されません。###</p>', '')
	// 				   .replace(/<p>/g, '');
	let arr = description.replace(/<p>/g, "").replace(/<\/p>/g, "").split('<br>');
	let productOptions = {};
	arr.forEach((keyval) => {
		let tempArr = keyval.split("：");
		if(tempArr.length == 2 && tempArr[0] != ""){
			productOptions[tempArr[0]] = tempArr[1]
		}
	});

	return productOptions;
}